import React, {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from '../FatalError/error.module.scss';
import Footer from '../../sharedUI/Footer/Footer';
import PrimaryButton from '../../sharedUI/button/PrimaryButton';
import { useAppContent } from "../../../shared/AppContent";
import {trackAdobeDncPages} from "../../../shared/AdobeUtility";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
import { funcUpdateCurrentAppState } from "../../../store/actions/AppStateActions";
import { RedirectToHelpScreen } from "../../../shared/utility";
// import { appNavigateTo } from "../../../store/actions/navActions";
import { getPartnerName } from "../../../shared/PartnerUtility";

export const FatalError = () => {
    // const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentAppState = useSelector((state) => state.AppState);
    const userDetail = useSelector((state) => state.User.UserDetail);
    const updateState = (currentAction, screenName) => dispatch(funcUpdateCurrentAppState(currentAction, screenName));
    const { technicalErrorContent } = useAppContent();

    
    useEffect(() => {
        let additionalArr={wipStepName:"fatal_error"};
        trackAdobeDncPages("error",currentAppState,"errorPage",userDetail,additionalArr);
        updateState("FatalError", "errorScreen");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const funcHandleClick = () => {
        // navigate(`/${currentAppState?.cardListDetails?.uniqueIdentifier}`);

        // if (currentAppState?.applicationBootFailed) {
        //     window.location.pathname = `/swift/${currentAppState?.cardListDetails?.uniqueIdentifier}`;
        // } else {
        //     if (currentAppState?.screenName) {
        //         dispatch(appNavigateTo({ goTo: "landingPage" }, "APP_NAVIGATE_TO"));
        //         updateState(currentAppState?.currentAction, currentAppState?.screenName);
        //     } else {
        //         dispatch(appNavigateTo({ goTo: "help" }, "APP_NAVIGATE_TO"));
        //     }
        // }
        const partner = getPartnerName();
        if (partner) {
            RedirectToHelpScreen("", currentAppState, "");
        }
        else {
        if (currentAppState?.cardListDetails?.uniqueIdentifier) {
            window.location.pathname = `/${process.env.REACT_APP_NAME}/${currentAppState?.cardListDetails?.uniqueIdentifier}`
        } else {
            window.location.reload(true);
        }
        }
    }

    return (
        <div className={classes.errorContainer}>
            <div className={classes.contentContainer}>
                <div className={`${classes.textContainer} ${classes.maintainerContainer}`}>
                    <h1 className={classes.errorText1}>{technicalErrorContent?.heading ? technicalErrorContent?.heading : 'Oops !'} </h1>
                    <p className={classes.errorText2}>{technicalErrorContent?.subheading ? technicalErrorContent?.subheading : 'We have encountered a problem. Please try after sometime.'}</p>
                    <br />
                    <p className={classes.errorText2}>{technicalErrorContent?.subheading2}</p>
                    <PrimaryButton
                        label={technicalErrorContent?.button ? technicalErrorContent?.button : 'Go to homepage'}
                        dataTestid="submit-button"
                        ext={"png"}
                        renditions={["2x"]}
                        handleClick={() => funcHandleClick()}
                        className={classes.button}
                        appState={currentAppState}
                    />
                </div>
            </div>
            <Footer className={classes.footer} />
        </div>
    );

}
export default FatalError;
